module.exports = __webpack_public_path__ + "static/media/document.716eeda2.png";